import HotelClassificationBusinessListListResultModelBase from '../_generated/modelBases/hotel-classification-business-list-list-result-model-base';

export default class HotelClassificationBusinessListListResultModel extends HotelClassificationBusinessListListResultModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
